/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssistantClearHistoryPostRequest
 */
export interface AssistantClearHistoryPostRequest {
    /**
     * 
     * @type {string}
     * @memberof AssistantClearHistoryPostRequest
     */
    conversationId: string;
}

/**
 * Check if a given object implements the AssistantClearHistoryPostRequest interface.
 */
export function instanceOfAssistantClearHistoryPostRequest(value: object): value is AssistantClearHistoryPostRequest {
    if (!('conversationId' in value) || value['conversationId'] === undefined) return false;
    return true;
}

export function AssistantClearHistoryPostRequestFromJSON(json: any): AssistantClearHistoryPostRequest {
    return AssistantClearHistoryPostRequestFromJSONTyped(json, false);
}

export function AssistantClearHistoryPostRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssistantClearHistoryPostRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'conversationId': json['conversationId'],
    };
}

export function AssistantClearHistoryPostRequestToJSON(json: any): AssistantClearHistoryPostRequest {
    return AssistantClearHistoryPostRequestToJSONTyped(json, false);
}

export function AssistantClearHistoryPostRequestToJSONTyped(value?: AssistantClearHistoryPostRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'conversationId': value['conversationId'],
    };
}

